import React from "react";
import tradeVideo from "../../assets/phonepress.mp4";
import { domain } from "../../data";
import { Link } from "react-router-dom";

const NewLandingUi = () => {
	return (
		<div className="relative min-h-full   flex items-center justify-center overflow-hidden">
			{/* Video Background */}
			<video
				className="absolute inset-0 w-full h-full  object-cover z-0"
				src={tradeVideo} // Replace with your MP4 video path
				autoPlay
				muted
				loop
				playsInline
			/>

			{/* Overlay Content */}
			<div className=" min-w-full   relative z-10 text-center px-4 py-8 bg-black bg-opacity-50 rounded-lg max-w-2xl mx-auto">
				<h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
					Welcome to {domain} Your gateway to enhanced and more informed
					trading.
				</h1>
				<p className="text-lg md:text-xl text-white mb-6">
					Execute trades swiftly across over 7,000 global assets, including
					EUR/USD, Ethereum, Silver, Microsoft, Brent Crude, and more.
				</p>

				<p className="text-[2rem]  text-white my-6">
					More than 3M+ active traders worldwide.
				</p>

				<Link
					to="en/register"
					className="bg-red-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-300">
					Create account
				</Link>
			</div>
		</div>
	);
};

export default NewLandingUi;
